export const NFT_CARD_MIN_WIDTH = 340;
export const MODAL_VIRTUALIZED_SCROLL_AREA_HEIGHT = 556;
